import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-emerald-950 pt-20 pb-16 md:py-32" data-id="element-67">
      {/* Background Accents */}
      <div className="absolute inset-0 bg-diagonal-stripes opacity-50 pointer-events-none" data-id="element-68" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-emerald-800/30 rounded-full blur-[120px] pointer-events-none" data-id="element-69" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-70">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-71">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-72">
            <FadeIn data-id="element-73">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-74">
                <span className="block text-white" data-id="element-75">STOP INFLAMING</span>
                <span className="block text-gradient-gold" data-id="element-76">YOUR BODY:</span>
                <span className="block text-3xl md:text-4xl lg:text-5xl mt-4 text-emerald-100/90 tracking-normal" data-id="element-77">
                  El Método Bio-Fitness de 28 Días
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-78">
              <p className="text-lg md:text-xl text-emerald-50/80 mb-10 max-w-2xl mx-auto lg:mx-0 font-body leading-relaxed" data-id="element-79">
                Deja de entrenar como un hombre y empieza a quemar grasa usando
                tu poder hormonal{' '}
                <span className="text-gold-400 font-medium" data-id="element-80">
                  (Sin dietas extremas ni agotamiento crónico)
                </span>
                .
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-81">
              <div className="flex justify-center lg:justify-start" data-id="element-82">
                <CTAButton className="w-full sm:w-auto" onClick={() => document.getElementById('oferta')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })} data-id="element-83">
                  ¡OBTENER MI PLAN BIO-FITNESS!
                </CTAButton>
              </div>
              <p className="mt-4 text-sm text-emerald-200/60 font-body" data-id="element-84"></p>
            </FadeIn>
          </div>

          {/* Product Image */}
          <FadeIn delay={0.3} className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-85">
            <div className="relative animate-float" data-id="element-86">
              {/* Glow behind image */}
              <div className="absolute inset-0 bg-gold-500/20 blur-[60px] rounded-full scale-75" data-id="element-87" />
              <img src="https://cdn.magicpatterns.com/uploads/mQqfbxQaKknG4BDSWsb4z4/Mockup_-_5to_Ebook.png" alt="Rutina Bio-Fitness: El Método ERBF Ebook en Tablet y Móvil" className="relative z-10 w-full h-auto drop-shadow-2xl transform -rotate-2" data-id="element-88" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}